const rootActionPath = 'core/RelatedCategoryFeaturedStores';

export const RELATED_CATEGORY_FEATURED_STORES_VIEW = `${rootActionPath}/VIEW`;
